<template>
    <b-modal v-model="isModalVisible" id="imgModal" size="lg" :no-header="true" :no-footer="true">
        <button class="close-button" @click="closeModal">&times;</button>
        <img :src="modalImageSrc" alt="Modal Image" id="imgInImgModal">
    </b-modal>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
const modalImageSrc = ref('');
const isModalVisible = ref(false);

const openModal = (imageSrc) => {
    modalImageSrc.value = imageSrc;
    isModalVisible.value = true;
};


onMounted(() => {
    const modalsButtons = document.querySelectorAll('.modal-image');

    modalsButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            const imagePath = button.getAttribute('data-photo');
            openModal(imagePath);
        });
    });
});

const closeModal = () => {
  isModalVisible.value = false;
};

watch(() => isModalVisible.value, (newVal) => {
    const langsBox = document.querySelector('.langs');
    if(!newVal){
        langsBox.style.zIndex = '99999';
    }
    else{
        langsBox.style.zIndex = '0';
    }
    
})
</script>
